import { Show } from "solid-js"
import { useLanguage } from "@/context/language"
import "@/datox/content-loading.css"

export function DatoxContentLoading(props: { title?: string; detail?: string }) {
  const language = useLanguage()
  return <div class="datox-content-loading" role="status" aria-live="polite">
    <span class="datox-content-loading__spinner" aria-hidden="true" />
    <strong>{props.title ?? language.t("common.loading")}</strong>
    <Show when={props.detail}><p>{props.detail}</p></Show>
  </div>
}
